// extracted by mini-css-extract-plugin
export default {"container":"CancelComponent-module__container__J3IiV","container-inner":"CancelComponent-module__container-inner__foeoV"};